import { create } from "zustand";

import imgP1 from "../assets/image/logo-main-black.png";
import imgP2 from "../assets/image/logo-main-black.png";

const defaultItems = [
  {
    id: "p1",
    title: "Amazon Echo Super Extra Bass Home System",
    img: imgP1,
    qty: 2,
    price: 70,
  },
  {
    id: "p2",
    title: "Apple AirPods with Wired Charging Case",
    img: imgP2,
    qty: 1,
    price: 150,
  },
];

// Example client store for cart-like state
export const useCartStore = create((set, get) => ({
  products: defaultItems,
  incProdQty: (productId) =>
    set({
      products: get().products.map((pr) =>
        pr.id === productId ? { ...pr, qty: pr.qty + 1 } : pr
      ),
    }),
  decProdQty: (productId) =>
    set({
      products: get().products.map((pr) => {
        if (pr.id === productId && pr.qty > 0) {
          return { ...pr, qty: pr.qty - 1 };
        }
        return pr;
      }),
    }),
  removeProduct: (productId) =>
    set({ products: get().products.filter(({ id }) => id !== productId) }),
  resetCart: () => set({ products: defaultItems }),
}));
